import { api } from './api';

/**
 * Accounts API client.
 * All methods return the unwrapped data (envelope stripped by api.js).
 * Throws ApiError on failure.
 */
export const accountsApi = {
  /**
   * List accounts (flat, paginated).
   * @param {object} params - { search, type, parentId, entityId, currencyId, isActive, page, limit }
   */
  list(params = {}) {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v != null && v !== '') q.append(k, String(v));
    });
    const qs = q.toString();
    return api.get(`/accounts${qs ? `?${qs}` : ''}`);
  },

  /**
   * Return all accounts as a nested tree.
   * Server builds the tree from parentId — frontend receives { id, children[], ...fields }.
   * @param {string} [entityId] - optional filter: shared + entity-specific accounts only
   */
  tree(entityId) {
    return api.get(`/accounts/tree${entityId ? `?entityId=${entityId}` : ''}`);
  },

  /** Dashboard stats: total, header/posting counts, by-currency. */
  stats() {
    return api.get('/accounts/stats');
  },

  /** Single account with opening balances. */
  get(id) {
    return api.get(`/accounts/${id}`);
  },

  /** Create a new account. */
  create(data) {
    return api.post('/accounts', data);
  },

  /** Update an existing account (PATCH — partial). */
  update(id, data) {
    return api.patch(`/accounts/${id}`, data);
  },

  /** Soft-delete (deactivate) an account. */
  remove(id) {
    return api.delete(`/accounts/${id}`);
  },

  /** Get all opening balances for an account across periods. */
  getOpeningBalances(id) {
    return api.get(`/accounts/${id}/opening-balances`);
  },

  /**
   * Set (upsert) an opening balance for one period.
   * @param {string} id - account id
   * @param {{ periodId, debitLocal, creditLocal, debitForeign, creditForeign }} data
   */
  setOpeningBalance(id, data) {
    return api.post(`/accounts/${id}/opening-balances`, data);
  },
};
